module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasError) ? _c('PageError') : _c('div', [_c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [(!_vm.metaRoute) ? _c('PageOrganization', _vm._b({
    attrs: {
      "wide-sidebar": true
    }
  }, 'PageOrganization', _vm.pageBinds, false), [_c('template', {
    slot: _vm.slotNames.SIDEBAR
  }, [_c('SidebarElement', [(_vm.isOrderPosible) ? _c('OrderDatepicker', {
    attrs: {
      "flag": true,
      "activeDates": _vm.activeDates,
      "disabledDates": _vm.disabledDates,
      "time-periods-by-dates": _vm.timePeriodsByDates,
      "selected-time-item": _vm.selectedTimeItem
    },
    on: {
      "update:selectedTimeItem": function($event) {
        _vm.selectedTimeItem = $event
      },
      "update:selected-time-item": function($event) {
        _vm.selectedTimeItem = $event
      }
    },
    model: {
      value: (_vm.dateOrder),
      callback: function($$v) {
        _vm.dateOrder = $$v
      },
      expression: "dateOrder"
    }
  }) : _vm._e(), _c('ButtonCanRequest', {
    attrs: {
      "isPossible": _vm.isOrderPosible,
      "wide": true
    },
    on: {
      "click": _vm.openForm
    }
  })], 1), _c('SidebarElement', {
    attrs: {
      "textAlignCenter": true
    }
  }, [_c('ButtonDeferred')], 1), (_vm.full.location) ? _c('SidebarElement', {
    attrs: {
      "title": "Адрес проведения"
    }
  }, [_vm._v(_vm._s(_vm.full.location))]) : _vm._e(), (_vm.full.level) ? _c('SidebarElement', {
    attrs: {
      "title": "Уровень"
    }
  }, [_vm._v(_vm._s(_vm.full.level))]) : _vm._e(), (_vm.full.educationFormName) ? _c('SidebarElement', {
    attrs: {
      "title": "Форма обучения"
    }
  }, [_vm._v(_vm._s(_vm.full.educationFormName))]) : _vm._e(), (_vm.full.members.length > 0) ? _c('SidebarElement', {
    attrs: {
      "title": "Участники"
    }
  }, [_vm._v(_vm._s(_vm.full.members.join(', ')))]) : _vm._e(), (_vm.full.persons) ? _c('SidebarElement', {
    attrs: {
      "title": "Максимальное количество участников"
    }
  }, [_vm._v(_vm._s(_vm.full.persons))]) : _vm._e(), (_vm.full.partnerName) ? _c('SidebarElement', {
    attrs: {
      "title": "Все мероприятия организатора"
    }
  }, [_c('ExtLink', {
    attrs: {
      "to": _vm.partnerLink
    }
  }, [_vm._v(_vm._s(_vm.full.partnerName))])], 1) : _vm._e(), (_vm.full.partnerPhone || _vm.full.partnerEmail) ? _c('SidebarElement', {
    attrs: {
      "title": "Контакты организации"
    }
  }, [(_vm.full.partnerPhone) ? _c('LinkElement', {
    attrs: {
      "phone": _vm.full.partnerPhone
    }
  }, [_vm._v(_vm._s(_vm.full.partnerPhone))]) : _vm._e(), (_vm.full.partnerEmail) ? _c('LinkElement', {
    attrs: {
      "mail": _vm.full.partnerEmail
    }
  }, [_vm._v(_vm._s(_vm.full.partnerEmail))]) : _vm._e()], 1) : _vm._e()], 1), (_vm.hasSlides) ? _c('SliderImages', {
    attrs: {
      "slot": _vm.slotNames.INSIDE,
      "items": _vm.slides,
      "color": _vm.colorMenuSection
    },
    slot: _vm.slotNames.INSIDE
  }) : _vm._e(), _c('TabsMenu', {
    attrs: {
      "items": _vm.menu
    }
  }), _c('TransitionFade', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 2) : _vm._e(), _c('router-view', _vm._b({
    attrs: {
      "name": "order"
    },
    on: {
      "onSubmit": _vm.onSubmit,
      "dateChanged": _vm.dateChanged,
      "backToActivity": _vm.backToActivity
    }
  }, 'router-view', _vm.orderBinds, false))], 1), (_vm.hasPrepared) ? _c('ExtraLayout', {
    attrs: {
      "bg": "gray"
    }
  }, [_c('ProgramsList', {
    attrs: {
      "usePadding": true,
      "items": _vm.activitiesPrepared,
      "doubler": false
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.bestProgramsTitle))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00acc65e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activities/card/component.vue
// module id = 47f4803255fcf01ab58a
// module chunks = 21